import { forwardRef, useState } from "react";
import { ExternalLink, Github } from "lucide-react";
import "../style/ProjectOverlay.scss";

const ProjectOverlay = forwardRef(({ project }, ref) => {
  const [mainImage, setMainImage] = useState(0);

  const hasImages = project?.images && project.images.length > 0;
  const hasTechStack = project?.techStack && project.techStack.length > 0;
  const hasLinks = project?.github || project?.liveUrl;

  return (
    <div className="projectOverlay" ref={ref}>
      {project && (
      <div className="projectOverlayContent">
        {hasImages && (
          <div className="imageSection">
            <div className="mainImageContainer">
              <img
                src={project.images[mainImage]}
                alt={`${project.title} screenshot`}
                className="mainImage"
              />
            </div>
            {project.images.length > 1 && (
              <div className="thumbnailRow">
                {project.images.map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    alt={`${project.title} thumbnail ${idx + 1}`}
                    className={`thumbnail ${idx === mainImage ? "active" : ""}`}
                    onClick={() => setMainImage(idx)}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        <div className="infoSection">
          <h2 className="title">{project.title}</h2>
          <p className="description">{project.description}</p>

          {hasTechStack && (
            <div className="techStack">
              {project.techStack.map((tech) => (
                <span key={tech} className="techTag">
                  {tech}
                </span>
              ))}
            </div>
          )}

          {hasLinks && (
            <div className="links">
              {project.github && (
                <a href={project.github} target="_blank" rel="noreferrer" className="link">
                  <Github size={18} />
                  <span>GitHub</span>
                </a>
              )}
              {project.liveUrl && (
                <a href={project.liveUrl} target="_blank" rel="noreferrer" className="link">
                  <ExternalLink size={18} />
                  <span>Live Site</span>
                </a>
              )}
            </div>
          )}
        </div>
      </div>
      )}
    </div>
  );
});

export default ProjectOverlay;
